import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { getTheme } from './theme';

export default function AppThemeProvider({ children }) {
  const themeState = useSelector((state) => state.settings.themeState);
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
  const mode = themeState === 'system' ? (prefersDark ? 'dark' : 'light') : themeState;
  const theme = useMemo(() => getTheme(mode), [mode]);

  useEffect(() => {
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', theme.palette.accent.main);
  }, [theme]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
